module.exports = "<mat-progress-spinner mode=\"indeterminate\"></mat-progress-spinner>"